"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Toolbar: true
};
exports.default = exports.Toolbar = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _tabbable = require("tabbable");
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _IconButton = require("../IconButton/IconButton");
var _Title = require("../Title/Title");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useFocusWithin = require("../utils/_useFocusWithin");
var _isFunction = require("../utils/isFunction");
var _useAutoOverflow = require("../utils/useAutoOverflow");
var _useFocusManager = require("../utils/useFocusManager");
var _useResponsiveSizes = require("../utils/useResponsiveSizes");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _isReactElement = require("../utils/isReactElement");
var _ToolbarLayout = require("./_ToolbarLayout");
var _ToolbarOverflow = require("./ToolbarOverflow");
var _ToolbarRegion = require("./_ToolbarRegion");
var _ToolbarSeparator = require("./_ToolbarSeparator");
var _responsiveOverflowUtils = require("./_responsiveOverflowUtils");
var _useArrowOnlyNavigation = require("./useArrowOnlyNavigation");
var _Toolbar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar.css") : void 0);
var _Toolbar2 = require("./Toolbar.types");
Object.keys(_Toolbar2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Toolbar2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Toolbar2[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/jsx-no-bind */

const CSS_BLOCK = 'sapcnqr-toolbar';
const DISPLAY_NAME = 'Toolbar';
const START_REGION_DISPLAY_NAME = `${DISPLAY_NAME}.Start`;
const CENTER_REGION_DISPLAY_NAME = `${DISPLAY_NAME}.Center`;
const END_REGION_DISPLAY_NAME = `${DISPLAY_NAME}.End`;
const unwrapFragments = children => {
  let unwrappedChildren = [];
  _react.default.Children.forEach(children, child => {
    if (/*#__PURE__*/_react.default.isValidElement(child) && child.type === _react.default.Fragment) {
      // If the child is a Fragment, recursively unwrap its children
      unwrappedChildren = unwrappedChildren.concat(unwrapFragments(child.props.children));
    } else {
      // Otherwise, add the child directly
      unwrappedChildren.push(child);
    }
  });
  return unwrappedChildren;
};
const CloneChildWithRegion = (child, regionName) => {
  var _a;
  return /*#__PURE__*/_react.default.cloneElement(child, Object.assign({}, (0, _isReactElement.isReactElement)(child, 'Tooltip') || (0, _isReactElement.isReactElement)(child, 'Overlay') ? {
    targetProps: Object.assign(Object.assign({}, (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.targetProps), {
      'data-toolbar-region': regionName
    })
  } : {
    'data-toolbar-region': regionName
  }));
};
const getChildNodes = (regionNode, regionName) => {
  var _a;
  let regionNodeChildren = ((_a = regionNode === null || regionNode === void 0 ? void 0 : regionNode.props) === null || _a === void 0 ? void 0 : _a.children) || [];
  if (typeof regionNodeChildren === 'string') {
    return [regionNodeChildren];
  }
  regionNodeChildren = unwrapFragments(regionNodeChildren);
  return _react.default.Children.map(regionNodeChildren, innerChild => /*#__PURE__*/_react.default.isValidElement(innerChild) && CloneChildWithRegion(innerChild, regionName));
};
/**
 * The **Toolbar** component acts as container for components.
 * It provides the styles, responsive behavior and keyboard interactions
 * needed to display components inline.
 */
const Toolbar = exports.Toolbar = Object.assign(/*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  var _a, _b;
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(Toolbar, _props)) : _props;
  const {
      ariaLabel,
      autoOverflow,
      children: childrenProp,
      className,
      customTitle,
      title,
      titleProps,
      toolbarStyle = 'solid',
      borderBottom,
      borderTop,
      breakpoints = {
        md: 600,
        lg: 1024,
        xl: 1440,
        xxl: 1920
      },
      containerBreakpoints,
      overflowButtonLabel,
      includeSeparatorAfterTitle,
      onSizeChange,
      overflowContainerRef,
      onOverflowToggle,
      overflowButtonProps,
      tableToolbar,
      toolbarProps,
      overflowFromStart,
      overflowOverlayProps,
      overflowMaxHeight,
      overflowContainerClassName,
      overflowContainerProps,
      navigationType = 'arrowKeysOnly',
      hideOuterFocusRing,
      ariaLabelledBy,
      customOverflowMenuTrigger,
      bypassChildren,
      showOverflowMenu
    } = props,
    otherProps = __rest(props, ["ariaLabel", "autoOverflow", "children", "className", "customTitle", "title", "titleProps", "toolbarStyle", "borderBottom", "borderTop", "breakpoints", "containerBreakpoints", "overflowButtonLabel", "includeSeparatorAfterTitle", "onSizeChange", "overflowContainerRef", "onOverflowToggle", "overflowButtonProps", "tableToolbar", "toolbarProps", "overflowFromStart", "overflowOverlayProps", "overflowMaxHeight", "overflowContainerClassName", "overflowContainerProps", "navigationType", "hideOuterFocusRing", "ariaLabelledBy", "customOverflowMenuTrigger", "bypassChildren", "showOverflowMenu"]);
  const [currentWidth, setCurrentWidth] = (0, _react.useState)();
  const [overflowOpen, setOverflowOpen] = (0, _react.useState)(showOverflowMenu);
  (0, _react.useEffect)(() => {
    setOverflowOpen(showOverflowMenu);
  }, [showOverflowMenu]);
  const internalToolbarContainerRef = (0, _react.useRef)(null);
  const internalToolbarRef = (0, _react.useRef)(null);
  const {
    isFocused
  } = (0, _useFocusWithin.useFocusWithin)({
    targetElement: internalToolbarContainerRef === null || internalToolbarContainerRef === void 0 ? void 0 : internalToolbarContainerRef.current
  });
  const overflowMenuRef = (0, _react.useRef)();
  const liveRegionRef = (0, _react.useRef)(null);
  const useLiveRegion = (0, _react.useRef)(false);
  const overflowKey = (0, _useUniqueId.default)();
  const classnames = _bind.default.bind(_Toolbar.default);
  const children = unwrapFragments(childrenProp);
  const childrenCount = _react.default.Children.count(children);
  const bypassChildrenCount = _react.default.Children.count(bypassChildren);
  let startProps = {};
  let centerProps = {};
  let endProps = {};
  const start = childrenCount ? _react.default.Children.map(children, eachChild => {
    if (! /*#__PURE__*/_react.default.isValidElement(eachChild)) {
      return null;
    }
    if ((0, _isReactElement.isReactElement)(eachChild, START_REGION_DISPLAY_NAME)) {
      startProps = eachChild.props;
      // include all the children of the Toolbar.Start component
      return getChildNodes(eachChild, 'start');
    }
    if (!(0, _isReactElement.isReactElement)(eachChild, CENTER_REGION_DISPLAY_NAME) && !(0, _isReactElement.isReactElement)(eachChild, END_REGION_DISPLAY_NAME)) {
      // include all the children of the Toolbar component
      // that are not Toolbar.Start, Toolbar.Center, or Toolbar.End
      return CloneChildWithRegion(eachChild, 'start');
    }
    // exclude all the children of the Toolbar.Center and Toolbar.End components
    return null;
  }) : [];
  const center = childrenCount ? _react.default.Children.map(children, eachChild => {
    if (! /*#__PURE__*/_react.default.isValidElement(eachChild)) {
      return null;
    }
    if ((0, _isReactElement.isReactElement)(eachChild, CENTER_REGION_DISPLAY_NAME)) {
      centerProps = eachChild.props;
      return getChildNodes(eachChild, 'center');
    }
    return null;
  }) : [];
  const end = childrenCount ? _react.default.Children.map(children, eachChild => {
    if (! /*#__PURE__*/_react.default.isValidElement(eachChild)) {
      return null;
    }
    if ((0, _isReactElement.isReactElement)(eachChild, END_REGION_DISPLAY_NAME)) {
      endProps = eachChild.props;
      return getChildNodes(eachChild, 'end');
    }
    return null;
  }) : [];
  const overflowMaps = (0, _react.useMemo)(() => {
    if (autoOverflow) return {};
    const smMap = {};
    const mdMap = {};
    const lgMap = {};
    const xlMap = {};
    let xxlMap = {};
    const mapChildLayout = (currentChild, sizeMaps) => {
      var _a;
      if ((0, _isReactElement.isReactElement)(currentChild, 'ToolbarLayout')) {
        const {
          overflowOrder,
          children: grandChildren = []
        } = currentChild.props;
        (0, _responsiveOverflowUtils.forEachSize)(eachSize => {
          if (currentChild.props[eachSize] === 'overflow') {
            (0, _responsiveOverflowUtils.addOverflowItemsToSizeMap)(sizeMaps[eachSize], overflowOrder, grandChildren);
          }
        });
      } else if ([START_REGION_DISPLAY_NAME, CENTER_REGION_DISPLAY_NAME, END_REGION_DISPLAY_NAME].indexOf((_a = currentChild === null || currentChild === void 0 ? void 0 : currentChild.type) === null || _a === void 0 ? void 0 : _a.displayName) !== -1 || (currentChild === null || currentChild === void 0 ? void 0 : currentChild.type) === _react.default.Fragment) {
        _react.default.Children.forEach(currentChild.props.children, grandChild => {
          mapChildLayout(grandChild, sizeMaps);
        });
      }
    };
    // allow xxl to inherit xl if not defined - we introduced xxl after the breakpoints
    // prop was already established, this is to prevent
    // the breaking change of xxl being required
    if (Object.keys(xxlMap).length === 0) {
      xxlMap = xlMap;
    }
    _react.default.Children.forEach(children, mainChild => {
      mapChildLayout(mainChild, {
        sm: smMap,
        md: mdMap,
        lg: lgMap,
        xl: xlMap,
        xxl: xxlMap
      });
    });
    return {
      sm: smMap,
      md: mdMap,
      lg: lgMap,
      xl: xlMap,
      xxl: xxlMap
    };
  }, [autoOverflow, childrenCount]);
  const classes = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}--${toolbarStyle}`]: !!toolbarStyle,
    [`${CSS_BLOCK}--border-bottom`]: !!borderBottom,
    [`${CSS_BLOCK}--border-top`]: !!borderTop,
    [`${CSS_BLOCK}__table`]: !!tableToolbar,
    [`${CSS_BLOCK}--outline`]: !hideOuterFocusRing && (navigationType === 'arrowKeysOnly' || navigationType === 'tabAndArrowsKeys') && isFocused
  });
  (0, _useResponsiveSizes.useResponsiveSizes)(currentSize => {
    setCurrentWidth(currentSize);
    onSizeChange === null || onSizeChange === void 0 ? void 0 : onSizeChange(currentSize);
  }, internalToolbarRef, breakpoints, containerBreakpoints);
  const handleOverflowToggle = open => {
    setOverflowOpen(!!open);
    if ((0, _isFunction.isFunction)(onOverflowToggle)) {
      onOverflowToggle(open);
    }
  };
  const renderOverflowMenu = overflowItems => (/*#__PURE__*/_react.default.createElement(_ToolbarOverflow.ToolbarOverflowComponent, {
    cssBlock: CSS_BLOCK,
    overflowButtonProps: overflowButtonProps,
    ref: (0, _reactMergeRefs.default)([overflowMenuRef, overflowContainerRef !== null && overflowContainerRef !== void 0 ? overflowContainerRef : null]),
    overflowButtonLabel: overflowButtonLabel,
    onOverflowToggle: handleOverflowToggle,
    key: overflowKey,
    overlayProps: overflowOverlayProps,
    maxHeight: overflowMaxHeight,
    showOverflowMenu: overflowOpen
  }, overflowItems));
  if (currentWidth && !autoOverflow && Object.keys((overflowMaps === null || overflowMaps === void 0 ? void 0 : overflowMaps[currentWidth]) || {}).length) {
    if (overflowFromStart) {
      start === null || start === void 0 ? void 0 : start.unshift(renderOverflowMenu((0, _responsiveOverflowUtils.getWidthItems)(overflowMaps, currentWidth)));
    } else {
      end === null || end === void 0 ? void 0 : end.push(renderOverflowMenu((0, _responsiveOverflowUtils.getWidthItems)(overflowMaps, currentWidth)));
    }
  }
  const passChildProps = (classnamesFn, child, childProps) => {
    var _a, _b, _c, _d;
    if (childProps['data-tooltip-target'] === true) {
      return {};
    }
    if (childProps['data-skip-toolbar'] === true) {
      return {};
    }
    if (child.displayName === 'Toolbar.End' || child.displayName === 'Toolbar.Center' || child.displayName === 'Toolbar.Start') {
      return {};
    }
    if (child.displayName === 'ToolbarLayout') {
      const widthBehavior = (0, _responsiveOverflowUtils.getWidthBehavior)(childProps, currentWidth);
      return {
        className: classnamesFn(childProps.className, `${CSS_BLOCK}__layout`),
        hide: widthBehavior === 'hide' || widthBehavior === 'overflow',
        replaceWith: typeof widthBehavior === 'object' && widthBehavior
      };
    }
    if (child.displayName === 'Tooltip') {
      return {
        targetProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.targetProps), {
          className: classnamesFn((_a = childProps === null || childProps === void 0 ? void 0 : childProps.targetProps) === null || _a === void 0 ? void 0 : _a.className, `${CSS_BLOCK}__item`)
        })
      };
    }
    if (child.displayName === 'Link' || child.displayName === 'IconLink') {
      return {
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, `${CSS_BLOCK}__item`, `${CSS_BLOCK}__link`),
        matchButtonHeight: true,
        innerTextClasses: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.innerTextClasses, `${CSS_BLOCK}__text`)
      };
    }
    if (child.displayName === 'Checkbox') {
      return {
        inline: true,
        className: classnamesFn(childProps.className, `${CSS_BLOCK}__item`)
      };
    }
    if (child.displayName === 'FormField') {
      useLiveRegion.current = true;
      let layoutProps = {};
      if (!childProps['data-skip-toolbar-layout']) {
        layoutProps = {
          layout: 'horizontal'
        };
      }
      return Object.assign(Object.assign({}, layoutProps), {
        className: classnamesFn(childProps.className, {
          [`${CSS_BLOCK}__item--skip-alignment`]: childProps['data-skip-toolbar-layout']
        }),
        validationOverlayProps: Object.assign(Object.assign({}, childProps.validationOverlayProps), {
          customLiveRegionRef: liveRegionRef
        }),
        labelProps: Object.assign(Object.assign({}, childProps.labelProps), {
          className: classnamesFn((_b = childProps === null || childProps === void 0 ? void 0 : childProps.labelProps) === null || _b === void 0 ? void 0 : _b.className, `${CSS_BLOCK}__label`)
        }),
        helpTextProps: Object.assign(Object.assign({}, childProps.helpTextProps), {
          className: classnamesFn((_c = childProps === null || childProps === void 0 ? void 0 : childProps.helpTextProps) === null || _c === void 0 ? void 0 : _c.className, `${CSS_BLOCK}__text`)
        }),
        inputProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.inputProps), {
          onKeyDown: (0, _chainFunction.default)((_d = childProps === null || childProps === void 0 ? void 0 : childProps.inputProps) === null || _d === void 0 ? void 0 : _d.onKeyDown, event => {
            var _a, _b, _c, _d;
            // suppress arrow, home, and end key events of an input in toolbar.
            // i.e. use these events to traverse the input field value
            // and not the toolbar items
            if (((0, _keycode.default)(event) === 'left' || (0, _keycode.default)(event) === 'right' || (0, _keycode.default)(event) === 'home' || (0, _keycode.default)(event) === 'end') && (navigationType === 'arrowKeysOnly' || navigationType === 'tabAndArrowsKeys') && (((_a = event === null || event === void 0 ? void 0 : event.currentTarget) === null || _a === void 0 ? void 0 : _a.selectionStart) !== 0 && ((0, _keycode.default)(event) === 'left' || (0, _keycode.default)(event) === 'home') || ((_b = event === null || event === void 0 ? void 0 : event.currentTarget) === null || _b === void 0 ? void 0 : _b.selectionEnd) !== ((_d = (_c = event === null || event === void 0 ? void 0 : event.currentTarget) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.length) && ((0, _keycode.default)(event) === 'right' || (0, _keycode.default)(event) === 'end'))) {
              event.stopPropagation();
            }
          })
        })
      });
    }
    if (child.displayName === 'SplitButton') {
      return {
        className: classnamesFn(childProps.className, `${CSS_BLOCK}__item`)
      };
    }
    // skip MessageListPopover in overflow unless we are provided design specs
    if (child.displayName === 'MessageListPopover') {
      return {
        triggerProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.triggerProps), {
          'data-no-overflow': true
        })
      };
    }
    return {
      type: tableToolbar && child.displayName === 'Button' && (childProps === null || childProps === void 0 ? void 0 : childProps.type) === 'primary' ? 'link' : childProps === null || childProps === void 0 ? void 0 : childProps.type,
      className: classnamesFn(childProps.className, `${CSS_BLOCK}__item`, {
        [`${CSS_BLOCK}__compact`]: child.displayName === 'Button' && childProps.type === 'link' && (childProps === null || childProps === void 0 ? void 0 : childProps.compact)
      })
    };
  };
  const internalOverflowContainerRef = (0, _react.useRef)(null);
  const overflowElement = /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({
    ariaLabel: "Placeholder",
    iconName: "kebab"
  }, overflowButtonProps, {
    className: classnames(`${CSS_BLOCK}__overflow-trigger`, overflowButtonProps === null || overflowButtonProps === void 0 ? void 0 : overflowButtonProps.className)
  }));
  const {
    childrenToRender = [],
    overflowChildrenToRender = []
  } = (0, _useAutoOverflow.useAutoOverflow)({
    disable: !autoOverflow,
    overflowFromStart,
    itemGap: 6,
    targetRef: internalOverflowContainerRef,
    children: [...(start !== null && start !== void 0 ? start : []), ...(center !== null && center !== void 0 ? center : []), ...(end !== null && end !== void 0 ? end : [])],
    overflowElement,
    overflownProps: (child, autoOverflowProps) => {
      var _a;
      if ((0, _isReactElement.isReactElement)(child, 'Overlay') || (0, _isReactElement.isReactElement)(child, 'Tooltip')) {
        return {
          targetProps: Object.assign(Object.assign({}, (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.targetProps), autoOverflowProps)
        };
      }
      return {};
    }
  });
  (0, _useArrowOnlyNavigation.useArrowOnlyNavigation)({
    containerRef: internalToolbarContainerRef,
    disabled: navigationType !== 'arrowKeysOnly'
  });
  const allowArrowKeyNav = navigationType !== 'tabKeyOnly';
  (0, _useFocusManager.useFocusManager)(Object.assign(Object.assign({}, allowArrowKeyNav ? {
    nextKeyCode: _keycode.default.codes.right,
    previousKeyCode: _keycode.default.codes.left
  } : {}), {
    firstFocusIndex: 0,
    suppressInitialAttachment: true,
    stopKeyPressPropagation: true,
    useHomeAndEndKeys: true,
    skipEvent: event => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
      if ((0, _keycode.default)(event) === 'tab' && navigationType === 'arrowKeysOnly' && internalToolbarContainerRef.current) {
        // suppress tab events if navigationType is 'arrowKeysOnly'
        const toolbarItems = (0, _tabbable.tabbable)(internalToolbarContainerRef.current);
        if ((event === null || event === void 0 ? void 0 : event.shiftKey) && (0, _useArrowOnlyNavigation.getPreviousEl)(toolbarItems)
        // suppress/handle 'shift + tab' only if there is a previous element
        // if there aren't any elements before the toolbar the focus
        // goes out of the DOM to the browser which we shouldn't prevent
        ) {
          event.preventDefault();
          return true;
        }
        if ((0, _useArrowOnlyNavigation.getNextEl)(toolbarItems)) {
          //
          // suppress/handle 'tab' only if there is a next element
          // if there isn't any element after the toolbar the focus
          // goes of the DOM to the browser which we shouldn't prevent
          event.preventDefault();
          return true;
        }
      }
      // skip Toolbar focus management for SegmentedButton as it
      // manages its own active descendants.
      const activeDescendantId = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.getAttribute) === null || _b === void 0 ? void 0 : _b.call(_a, 'aria-activedescendant');
      // if there is no active descendant, don't skip focus management
      if (!activeDescendantId) {
        return false;
      }
      let firstOptionId = (_e = (_d = (_c = event.target) === null || _c === void 0 ? void 0 : _c.firstElementChild) === null || _d === void 0 ? void 0 : _d.getAttribute) === null || _e === void 0 ? void 0 : _e.call(_d, 'id');
      const lastOptionId = (_f = event.target) === null || _f === void 0 ? void 0 : _f.lastElementChild.getAttribute('id');
      // if segmented button has label get the 1st option like this:
      if (((_j = (_h = (_g = event.target) === null || _g === void 0 ? void 0 : _g.firstElementChild) === null || _h === void 0 ? void 0 : _h.getAttribute) === null || _j === void 0 ? void 0 : _j.call(_h, 'role')) === 'presentation') {
        firstOptionId = (_m = (_l = (_k = event.target) === null || _k === void 0 ? void 0 : _k.childNodes[1]) === null || _l === void 0 ? void 0 : _l.getAttribute) === null || _m === void 0 ? void 0 : _m.call(_l, 'id');
      }
      // if the active descendant is not the first or last option, skip focus management
      return activeDescendantId !== lastOptionId && (0, _keycode.default)(event) === 'right' || activeDescendantId !== firstOptionId && (0, _keycode.default)(event) === 'left';
    }
  }), !overflowOpen && isFocused && allowArrowKeyNav, internalToolbarContainerRef);
  const getRegionChildren = (allChildren, regionName) => allChildren === null || allChildren === void 0 ? void 0 : allChildren.filter(child => {
    var _a, _b, _c;
    return ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a['data-toolbar-region']) === regionName || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.targetProps) === null || _c === void 0 ? void 0 : _c['data-toolbar-region']) === regionName;
  });
  const getActualChildren = allChildren => allChildren === null || allChildren === void 0 ? void 0 : allChildren.filter(child => {
    var _a;
    return !((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a['aria-hidden']);
  });
  let startChildrenToRender = start;
  let centerChildrenToRender = center;
  let endChildrenToRender = end;
  let overflowMenuTrigger = customOverflowMenuTrigger || null;
  if (autoOverflow) {
    startChildrenToRender = getRegionChildren(childrenToRender, 'start');
    centerChildrenToRender = getRegionChildren(childrenToRender, 'center');
    endChildrenToRender = getRegionChildren(childrenToRender, 'end');
    if (Array.isArray(overflowChildrenToRender) && overflowChildrenToRender.length) {
      overflowMenuTrigger = renderOverflowMenu(overflowChildrenToRender);
    }
  }
  let toolbarAriaLabel = ariaLabel;
  if (!toolbarAriaLabel && typeof title === 'string') {
    toolbarAriaLabel = title;
  }
  const contextualChildren = regionalChildren => (/*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps.bind(null, classnames)
  }, regionalChildren));
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    className: classes,
    ref: (0, _reactMergeRefs.default)([ref, internalToolbarContainerRef])
  }), (typeof title === 'string' ? title.trim() : title) && (customTitle ? title : (/*#__PURE__*/_react.default.createElement(_Title.Title, Object.assign({
    headingLevel: 4
  }, titleProps, {
    className: classnames(`${CSS_BLOCK}__title`, titleProps === null || titleProps === void 0 ? void 0 : titleProps.className)
  }), title))), includeSeparatorAfterTitle && (autoOverflow && _react.default.Children.count(getActualChildren(childrenToRender)) > 0 || !autoOverflow) && /*#__PURE__*/_react.default.createElement(_ToolbarSeparator.ToolbarSeparator, {
    role: "presentation",
    "aria-hidden": true
  }), (childrenCount > 0 || autoOverflow && _react.default.Children.count(getActualChildren(childrenToRender)) > 0) && contextualChildren(/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, overflowFromStart && overflowMenuTrigger, /*#__PURE__*/_react.default.createElement("div", Object.assign({}, toolbarProps, {
    "aria-labelledby": ariaLabelledBy,
    className: classnames(`${CSS_BLOCK}__toolbar`, toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.className),
    role: "toolbar",
    "aria-label": toolbarAriaLabel,
    ref: (0, _reactMergeRefs.default)([(_a = toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.ref) !== null && _a !== void 0 ? _a : null, internalToolbarRef])
  }), /*#__PURE__*/_react.default.createElement("div", Object.assign({}, overflowContainerProps, {
    className: classnames(overflowContainerProps === null || overflowContainerProps === void 0 ? void 0 : overflowContainerProps.className, overflowContainerClassName, `${CSS_BLOCK}__overflow-container`, {
      [`${CSS_BLOCK}__overflow-container--scroll`]: !autoOverflow
    }),
    ref: internalOverflowContainerRef
  }), startChildrenToRender && startChildrenToRender.length > 0 && (/*#__PURE__*/_react.default.createElement(Toolbar.Start, Object.assign({}, startProps), contextualChildren(startChildrenToRender))), centerChildrenToRender && centerChildrenToRender.length > 0 && (/*#__PURE__*/_react.default.createElement(Toolbar.Center, Object.assign({}, centerProps), contextualChildren(centerChildrenToRender))), endChildrenToRender && endChildrenToRender.length > 0 && (/*#__PURE__*/_react.default.createElement(Toolbar.End, Object.assign({}, endProps), contextualChildren(endChildrenToRender))), bypassChildren)), !overflowFromStart && overflowMenuTrigger)), bypassChildren && bypassChildrenCount > 0 && !autoOverflow && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, overflowFromStart && overflowMenuTrigger, /*#__PURE__*/_react.default.createElement("div", Object.assign({}, toolbarProps, {
    "aria-labelledby": ariaLabelledBy,
    className: classnames(`${CSS_BLOCK}__toolbar`, toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.className),
    role: "toolbar",
    "aria-label": toolbarAriaLabel,
    ref: (0, _reactMergeRefs.default)([(_b = toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.ref) !== null && _b !== void 0 ? _b : null, internalToolbarRef])
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(overflowContainerClassName, `${CSS_BLOCK}__overflow-container`, `${CSS_BLOCK}__overflow-container--scroll`),
    ref: internalOverflowContainerRef
  }, /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps.bind(null, classnames)
  }, bypassChildren))), !overflowFromStart && overflowMenuTrigger)), useLiveRegion.current && (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__live-region`),
    "data-test": "toolbar-status",
    "aria-live": "polite",
    role: "status",
    ref: liveRegionRef
  })));
}), {
  displayName: DISPLAY_NAME,
  Start: (0, _ToolbarRegion.ToolbarRegion)(START_REGION_DISPLAY_NAME),
  Center: (0, _ToolbarRegion.ToolbarRegion)(CENTER_REGION_DISPLAY_NAME),
  End: (0, _ToolbarRegion.ToolbarRegion)(END_REGION_DISPLAY_NAME),
  Layout: _ToolbarLayout.ToolbarLayout,
  Separator: _ToolbarSeparator.ToolbarSeparator
});
var _default = exports.default = Toolbar;